import axios from 'axios';
import { apiRoutes } from '../../../../config';
import { keyAccessToken, keyUserId } from '../../../../assets/js/SessionStorageNames';

const buildCategoryTree = (categories) => {
    const categoryMap = {};
    const rootCategories = [];

    // Primero creamos un mapa de todas las categorías
    categories.forEach(category => {
        categoryMap[category.categoryId] = {
            ...category,
            children: []
        };
    });

    // Luego construimos el árbol
    categories.forEach(category => {
        if (category.parent && categoryMap[category.parent]) {
            // Si tiene padre, lo agregamos como hijo
            categoryMap[category.parent].children.push(categoryMap[category.categoryId]);
        } else if (!category.parent) {
            // Si no tiene padre, es una categoría raíz
            rootCategories.push(categoryMap[category.categoryId]);
        }
    });

    return rootCategories;
};

export const getAllCategoriesFalabella = (entId, axiosCancelTokenSource) => {
    console.log(`${apiRoutes.falabella.categories}/getCatTree/${entId} la ruta de falabella`)
    return axios.get(
        `${apiRoutes.falabella.categories}/getCatTree/${entId}`,
        {
            headers: {
                "x-api-key": process.env.REACT_APP_API_KEY,
                "x-access-token": localStorage.getItem(keyAccessToken),
                "x-user-id": localStorage.getItem(keyUserId),
            },
            cancelToken: axiosCancelTokenSource.token,
        }
    ).then(response => {
        console.log('Response completa:', response.data);
        const categories = response.data.data;
        console.log('Categorías antes de procesar:', categories);
        const treeCategories = buildCategoryTree(categories);
        console.log('Árbol de categorías:', treeCategories);
        return {
            ...response,
            data: {
                data: treeCategories,
                total: categories.length
            }
        };
    });
};

export default getAllCategoriesFalabella;

